import useToggleModal from "hooks/useToggleModal";
import React, { createContext, ReactNode, useContext, useState } from "react";
import AppointmentSeriesModal from "./components/confirm-cancel-series-modal/ConfirmCancelSeriesModal";

type Context = {
  openAppointmentSeriesModal: (arg: { appointment; onCancelled }) => void;
  closeAppointmentSeriesModal: () => void;
};
const AppointmentSeriesModalContext = createContext<Context>({
  openAppointmentSeriesModal: () => null,
  closeAppointmentSeriesModal: () => null,
});

type Props = { children: ReactNode };

export const AppointmentSeriesModalContextProvider = ({ children }: Props) => {
  const {
    open: openAppointmentSeriesModal,
    close: closeAppointmentSeriesModal,
    show,
  } = useToggleModal(false);

  const [appointment, setAppointment] = useState<AppointmentWithSeriesInfo>();
  const [onCancelled, setOnCancelled] = useState<(() => void) | null>(null);

  const handleOpen = ({
    appointment,
    onCancelled,
  }: {
    appointment: AppointmentWithSeriesInfo;
    onCancelled: () => void;
  }) => {
    setAppointment(appointment);
    setOnCancelled(() => onCancelled);
    openAppointmentSeriesModal();
  };

  const handleClose = () => {
    closeAppointmentSeriesModal();
  };

  return (
    <>
      <AppointmentSeriesModalContext.Provider
        value={{
          openAppointmentSeriesModal: handleOpen,
          closeAppointmentSeriesModal: handleClose,
        }}
      >
        {children}
      </AppointmentSeriesModalContext.Provider>
      {appointment && (
        <AppointmentSeriesModal
          appointment={appointment}
          onCancelled={onCancelled}
          show={show}
          onHide={() => handleClose()}
        />
      )}
    </>
  );
};

export const useAppointmentSeriesModalContext = () =>
  useContext(AppointmentSeriesModalContext);
